export const SET_TOP_BANNER_IMAGE_PATH = 'SET_TOP_BANNER_IMAGE_PATH';
export const SET_TITLE = 'SET_TITLE';
export const SET_SUBTITLE = 'SET_SUBTITLE';



// WEBPACK FOOTER //
// ./src/features/shared/topBanner/constants.js